import { useFeatureFlagEnabled } from '@posthog/react';

/** PostHog flag key gating the Site Data (Field Notes + Potholes) layer section. Evaluated against the active `organization` group. */
export const SITE_DATA_LAYER_FLAG = 'site-data-layer-enabled';

/**
 * Org-scoped kill switch for the Site Data layer section. Fail-closed: `undefined`/`false`
 * from PostHog (including while flags are still loading) hides the section.
 */
export function useSiteDataLayerEnabled(): boolean {
  return useFeatureFlagEnabled(SITE_DATA_LAYER_FLAG) === true;
}
